import React, { createContext, useState, useEffect } from "react";

export const LeagueContext = createContext();

export const LeagueProvider = ({ children }) => {
  // Synchronous restore before first render
  const savedLeagueID = (() => {
    try {
      return localStorage.getItem("currentLeagueID") || null;
    } catch {
      return null;
    }
  })();

  const [currentLeagueID, setCurrentLeagueID] = useState(savedLeagueID);

  // Persist updates to localStorage
  useEffect(() => {
    if (currentLeagueID) {
      localStorage.setItem("currentLeagueID", currentLeagueID);
    }
  }, [currentLeagueID]);

  // Listen for cross-tab updates
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "currentLeagueID" && e.newValue !== currentLeagueID) {
        setCurrentLeagueID(e.newValue);
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [currentLeagueID]);

  // Manual refresh helper
  const refreshLeagueID = () => {
    const stored = localStorage.getItem("currentLeagueID");
    if (stored && stored !== currentLeagueID) {
      setCurrentLeagueID(stored);
    }
  };

  return (
    <LeagueContext.Provider
      value={{ currentLeagueID, setCurrentLeagueID, refreshLeagueID }}
    >
      {children}
    </LeagueContext.Provider>
  );
};